import {Route, Routes} from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Home from './pages/Dashboard/Home';
import Login from './pages/Login';
import Order from './pages/Dashboard/Order';
import OrderCreate from './pages/Dashboard/Order/create';
import Mng from './pages/Dashboard/Mng';
import Declined from './pages/Dashboard/Declined';
import Confirm from './pages/Dashboard/Confirm';
import Users from './pages/Dashboard/Users';
import Leasing from './pages/Dashboard/Leasing';
import DeliveryConf from './pages/Dashboard/Delivery/conf';
import DeliveryReq from './pages/Dashboard/Delivery/request';
import BelenBaraa from './pages/Dashboard/BelenBaraa/index';
import BelenBaraaAdd from './pages/Dashboard/BelenBaraa/add';
import BelenBaraaOrders from './pages/Dashboard/BelenBaraa/orders';
import BelenBaraaOrdersPayed from './pages/Dashboard/BelenBaraa/ordersPayed';
import BelenBaraaOrdersConfirm from './pages/Dashboard/BelenBaraa/ordersConfirm';

function App() {
  return (
    <>
        <Routes>
            <Route path='/' element={<Login/>}/>
            <Route path="/dashboard" element={<Dashboard />}>

            <Route index element={<Home/>}/>
              <Route path="order" element={<Order/>}/>
              <Route path="users" element={<Users/>}/>
              <Route path="create-order" element={<OrderCreate/>}/>
              <Route path="mng" element={<Mng/>}/>
              <Route path="declined" element={<Declined/>}/>
              <Route path="confirm" element={<Confirm/>}/>
              <Route path="leasing" element={<Leasing/>}/>
              <Route path="delivery-req" element={<DeliveryReq/>}/>
              <Route path="delivery-conf" element={<DeliveryConf/>}/>
              <Route path="belen" element={<BelenBaraa/>}/>
              <Route path="belen-add" element={<BelenBaraaAdd/>}/>
              <Route path="belen-order" element={<BelenBaraaOrders/>}/>
              <Route path="belen-payed" element={<BelenBaraaOrdersPayed/>}/>
              <Route path="belen-confirm" element={<BelenBaraaOrdersConfirm/>}/>
              
            </Route>
        </Routes>

    </>
  );
}

export default App;
